import React, { useEffect, useState } from 'react';
import { Alert, ListGroup, Spinner } from 'react-bootstrap';
import { useUser } from '../components/UserContext.tsx';
import { canViewPastoralPrompts } from './schoolClaims.ts';
import { fetchSchoolNotices, type SchoolNotice } from './schoolApi.ts';
import SchoolDeskPage from './SchoolDeskPage.tsx';

export default function SchoolPromptsPage() {
  const { activeUser } = useUser();
  const [notices, setNotices] = useState<SchoolNotice[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!canViewPastoralPrompts(activeUser)) return;
    let cancelled = false;
    fetchSchoolNotices()
      .then((data) => {
        if (!cancelled) setNotices(data.notices || []);
      })
      .catch((cause) => {
        if (!cancelled) setError(cause instanceof Error ? cause.message : 'Could not load notices');
      });
    return () => {
      cancelled = true;
    };
  }, [activeUser]);

  if (!canViewPastoralPrompts(activeUser)) {
    return (
      <SchoolDeskPage title="School notices">
        <Alert variant="secondary">This desk is for class teachers, parents, and named leads.</Alert>
      </SchoolDeskPage>
    );
  }

  return (
    <SchoolDeskPage title="School notices">
      <p>Pastoral prompts never include classmate chat. Help notices name the child who asked, not the thread.</p>
      {error && <Alert variant="danger">{error}</Alert>}
      {notices == null && !error && <Spinner animation="border" />}
      {notices && notices.length === 0 && <p>No notices yet.</p>}
      {notices && notices.length > 0 && (
        <ListGroup>
          {notices.map((notice) => (
            <ListGroup.Item key={notice.id}>
              <strong>{notice.title}</strong>
              <div>{notice.body}</div>
            </ListGroup.Item>
          ))}
        </ListGroup>
      )}
    </SchoolDeskPage>
  );
}
